import { useEffect, useLayoutEffect } from "react";
import { trunketName } from "../../../base/video_common";
import store from '../../../store/redux-store/root_store';
import styles from "../videoscreen.module.scss";
import { useSelector } from "react-redux";
import loadersimg from "../../../styles/images/br-login-animated-dots.json";
import Lottie from "lottie-react";

type ccprops={
    type?:any;
}
export default function CloseCaptionCommon ({type}:ccprops){
const {closeCaptionText,showOriginalText,expandHide}=store.getState().closeCaption;
const {currdeviceinfo}=store.getState().meetingReducer;
const closeCaption: any = useSelector((state: any) => state.closeCaption);

useEffect(()=>{
  
},[JSON.stringify(closeCaption)])

let index: any = closeCaptionText?.length
let element: any = document.getElementById("original" + (index - 1));
let ccelement: any = document.getElementById("closecaption");
useLayoutEffect(() => {
  if (element != null) {
    element.scrollTop = element?.scrollHeight - element?.clientHeight;
    element.scrollIntoView({ behavior: 'smooth', block: 'end' });
    element.scrollTo(0,element.scrollHeight);
  }

  if (ccelement) {
    ccelement.scrollTop = ccelement?.scrollHeight - ccelement?.clientHeight;
    ccelement.scrollIntoView({ behavior: 'smooth', block: 'end' })
    ccelement.scrollTo(0,ccelement.scrollHeight);
  }
}, [element?.scrollHeight,element?.scrollTop,closeCaptionText,JSON.stringify(closeCaption)])

  return (
    <>
      <div className={type === "customer" ? styles.maincaption : `${styles.agentcaptions} ${styles.maincaption}`}>
        
        <div className={styles.maincaptioninner} id="closecaption">
        {closeCaptionText.length > 0 && closeCaptionText.map((ele: any, i: any) => {
                      return (
                        
                        <div className={!expandHide ? `${styles.singlecaption} ${styles.maxseccontain}` : `${styles.singlecaption} ${styles.minseccontain}`} key={i}>
                          <div className={styles.ccprofiletxt}>
                            <div className={!showOriginalText ? `${styles.closedcaptioncontentsec} ${styles.ifOriginal} ` : `${styles.closedcaptioncontentsec}`}>
                              {!showOriginalText && <div className={`${styles.cckkkkk} ${styles.ccheight}`}>
                              <p
                              ><span className={styles.ccName}>{closeCaptionText[i]?.Connection_Id === currdeviceinfo.conId ? "You" : trunketName(closeCaptionText[i]?.speakerName)}</span><span  id={"original" + i} className={styles.ccDesc}>{closeCaptionText[i]?.finalconvertedText }</span></p>
                              </div>}
                              {/* {showOriginalText && <><div className={`${styles.cckkkkk} ${styles.ccheight}`}>
                              <p id={"original" + i}
                              ><span className={styles.ccName}>{closeCaptionText[i]?.Connection_Id === currdeviceinfo.conId ? "You" : trunketName(closeCaptionText[i]?.speakerName)}</span><span className={styles.ccDesc}>{closeCaptionText[i]?.finalText }</span></p>
                              </div>
                               <p className={styles.translatedText} id={"translate" + i}><span>{closeCaptionText[i].finalconvertedText}</span></p></>} */}
  
                            </div>
  
  
                          </div>
                        </div>)
                    })
                    }
{    closeCaptionText.length === 0  &&  <div className="ccloader"><Lottie className="lottieimg" animationData={loadersimg} /></div>}
  </div>
  </div>
    </>
  );
}
